import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function ChinaSpreadsheetAgent() {
  return <ArticleLayout slug="china-spreadsheet-agent" />;
}